"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommerceTermsType = void 0;
var CommerceTermsType;
(function (CommerceTermsType) {
    CommerceTermsType["SHOPBY"] = "SHOPBY";
    CommerceTermsType["SHOPBYPRO"] = "SHOPBYPRO";
    CommerceTermsType["SHOPBYPREMIUM"] = "SHOPBYPREMIUM";
    CommerceTermsType["GODOMALL"] = "GODOMALL";
    CommerceTermsType["PRIVACY"] = "PRIVACY";
    CommerceTermsType["JOININTEGRATE"] = "JOININTEGRATE";
    CommerceTermsType["PRIVACYSHOPBYPREMIUM"] = "PRIVACYSHOPBYPREMIUM";
    CommerceTermsType["WORKSPACE"] = "WORKSPACE";
    CommerceTermsType["DEVCENTER"] = "DEVCENTER";
    CommerceTermsType["APPSTORE"] = "APPSTORE";
    CommerceTermsType["SHOPBY_INTEGRATE"] = "SHOPBY_INTEGRATE";
    CommerceTermsType["DOMAIN_PRIVACY_COLLECTION"] = "DOMAIN_PRIVACY_COLLECTION";
    CommerceTermsType["DOMAIN_PRIVACY_PROCESSING"] = "DOMAIN_PRIVACY_PROCESSING";
    CommerceTermsType["SSL_PRIVACY_COLLECTION"] = "SSL_PRIVACY_COLLECTION";
    CommerceTermsType["SSL_PRIVACY_PROCESSING"] = "SSL_PRIVACY_PROCESSING";
})(CommerceTermsType = exports.CommerceTermsType || (exports.CommerceTermsType = {}));
;
